import { Link, Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuthStore } from '../../stores/authStore';
import { GbrPage, AppTop, PublicTop, SiteFooter, Tabs } from './Shell';
import '../../styles/gbr-pages.css';

/** Route-level frame for every page that is not yet built on GbrPage itself: same top menu, footer and tab bar as Home/Library. */
export default function GbrFrame({ pad }: { pad?: boolean }) {
  const { isAuthenticated } = useAuthStore();
  return (
    <GbrPage>
      {isAuthenticated ? <AppTop /> : <PublicTop />}
      <div className="pg">
        {pad ? <div className="pad"><Outlet /></div> : <Outlet />}
      </div>
      <SiteFooter />
      <Tabs app={isAuthenticated} />
    </GbrPage>
  );
}

export function NotFound() {
  return (
    <div className="pgc">
      <Helmet>
        <title>Page not found | GetBookReviews</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="nf">
        <b>404</b>
        <h1 style={{ fontSize: 28 }}>This page is not on our shelf</h1>
        <p>The link may be old or mistyped. Try one of these instead.</p>
        <Link className="btn p" to="/">Home</Link>
        <Link className="btn o" to="/library">Library</Link>
        <Link className="btn o" to="/faq">FAQ</Link>
      </div>
    </div>
  );
}
